<template>
  <v-navigation-drawer
    v-model="isMenuActive"
    class="nav-drawer text-left"
    bottom
    temporary
    width="300"
  >
    <v-list>
      <v-list-item
        v-for="item in sidebar"
        :key="item.title"
        :title="item.title"
        :to="item.to"
        :prepend-icon="item.icon"
        link
      ></v-list-item>

      <v-spacer />
      <v-divider />

      <v-list-item prepend-icon="$signOut" @click="signOut">
        Sign Out
      </v-list-item>
      <SfiThemeToggle rounded="0" />
    </v-list>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAuth } from '@simplifi/auth'
import { useNav } from '@simplifi/components'
const { isMenuActive } = useNav()
const { signOut } = useAuth()
const sidebar = ref([
  {
    title: 'Home',
    icon: '$home',
    to: { name: 'home' },
  },
])
</script>

<style scoped>
/* Style list as flex so we can push things to the bottom easily */
/* Also allow overflow-y so if the menu gets large / used on mobile we can scroll it */
.v-list {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  overflow-y: auto !important;
  padding: 0;
}
/* Prevent menu items being visually selectable */
.v-list-item-title {
  user-select: none;
}
.v-list-group {
  --prepend-width: 10px !important;
}
</style>
